<div class="processing-status-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow" *ngIf="processingStatus != null && processingStatus.length > 0">
            <mat-label>
                {{'processing status' |
                translate:['tmc-yard.widgets.filter-administration.details-editor.transport.processing-status-editor.processing-status',
                translationService.language]}}
            </mat-label>
            <mat-select formControlName="processingStatus" name="processingStatus">
                <mat-option *ngFor="let o of processingStatus" [value]="o.key">
                    {{o.dictionaryKey | translate: [o.dictionaryKey, translationService.language]}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>